{
  "field_required": "Ce champs est obligatoire",
  "title": "Titre",
  "number": "Nombre",
  "crew_submit": "Ajouter un team"
}
